
import { Vue, Component, namespace } from "nuxt-property-decorator";
import BreadCrumb from "~/components/molecules/display/BreadCrumb.vue";
import TransformNavigationMenu from "~/components/organisms/nav/TransformNavigationMenu.vue";

const BreadCrumbModule = namespace("breadcrumb");

type TransformMenuItems = {
  name: string;
  title: string;
  link: { path: string };
  externalLink: boolean;
};

@Component({
  scrollToTop: true,
  components: {
    TransformNavigationMenu,
    BreadCrumb,
  },
})
export default class BlogIndexPage extends Vue {
  @BreadCrumbModule.State("breadCrumbNews")
  breadCrumbNews;

  layout(cxt) {
    return cxt.route.query?.shortVersion ? "empty" : "default";
  }

  isShortVersion = this.$route.query?.shortVersion ?? false;

  transformMenuItems: Array<TransformMenuItems> = [
    {
      name: "News",
      title: "News zum Thema Heizölpreise",
      link: { path: "/news" },
      externalLink: false,
    },
    {
      name: "News-Archiv",
      title: "New zur Heizölpreisentwicklung der letzten Monate und Jahre",
      link: { path: "/news/archiv" },
      externalLink: false,
    },
    {
      name: "Charts",
      title: "Heizölpreise und Ölpreise im Blick bei esyoil",
      link: { path: "/news/charts" },
      externalLink: false,
    },
  ];

  getActiveTabName(): string {
    if (this.$route.params.id) {
      return this.transformMenuItems[0].name;
    }
    return this.transformMenuItems.filter((ele) => {
      return this.$route.fullPath === ele.link.path;
    })[0]?.name;
  }
}
